import { useState } from "react";

type SafeImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

const SafeImage = ({ className, onError, ...props }: SafeImageProps) => {
    const [isHidden, setIsHidden] = useState(false);

    if (isHidden) {
        return null;
    }

    return (
        <img
            {...props}
            className={className}
            onError={(event) => {
                setIsHidden(true);
                onError?.(event);
            }}
        />
    );
};

export default SafeImage;
